import React, { useState, useEffect } from 'react';
import { CardContent, Box, Typography, Slider, TextField, Grid } from '@mui/material';
import { useAppContext } from '../context/AppContext'; // update path as needed
import { api } from '../utils/api';

const KidsPlanning = () => {
  const { state, actions } = useAppContext();
  const [numKids, setNumKids] = useState(0);
  const [kidsInfo, setKidsInfo] = useState([]);
  const currentYear = new Date().getFullYear();

  const syncKidsState = (updatedKids) => {
    const updatedEducation = updatedKids.map((kid, index) => ({
      ...(state.kidsEducation?.[index] || {}),
      ...kid,
    }));

    setKidsInfo(updatedKids);
    actions.updateFormData('kidsInfo', updatedKids);
    actions.updateFormData('kidsEducation', updatedEducation);
  };

  // Initialize component with existing data from context
  useEffect(() => {
    if (state.kidsInfo && state.kidsInfo.length > 0) {
      const updatedKids = state.kidsInfo.map(kid => ({
        ...kid,
        Age: kid.Age || (currentYear - Number(kid.yearOfBirth || 0)),
      }));
      setKidsInfo(updatedKids);
      setNumKids(updatedKids.length);
  
      // Validation logic: ensure name and yearOfBirth are filled
      const isValid = updatedKids.every(kid => kid.name?.trim() !== '' && /^[12]\d{3}$/.test(String(kid.yearOfBirth || '')));
      // const isValid = updatedKids.every(kid => kid.name?.trim() !== '' && kid.yearOfBirth !== 0);
      actions.updateFormData('kidsPlanningValid', isValid);
    } else {
      setKidsInfo([]);
      setNumKids(0);
      actions.updateFormData('kidsEducation', []);
      actions.updateFormData('kidsPlanningValid', true); // No kids = valid
    }
  }, [state.kidsInfo, currentYear]); // eslint-disable-line react-hooks/exhaustive-deps
  
  

  const handleSliderChange = (event, newValue) => {
    setNumKids(newValue);
    const updatedKids = [];
    for (let i = 0; i < newValue; i++) {
      updatedKids.push(kidsInfo[i] || { name: '', yearOfBirth: 0 });
    }
    syncKidsState(updatedKids);

    if (newValue === 0 && state.phoneNumber) {
      api.put('/users/' + state.phoneNumber + '/children/sync', []).catch((err) => {
        console.error('syncChildrenInfo failed:', err);
      });
    }
  };

  const handleInputChange = (index, field, value) => {
    const updated = [...kidsInfo];
    if (field === "yearOfBirth") {
      const year = Number(value) || 0;
      updated[index][field] = year;
      updated[index]["Age"] = year ? currentYear - year : 0;
    }
    else{
      updated[index][field] = value;
    }
    syncKidsState(updated);
  };

  return (
    <CardContent>
      <Box>
        <Typography variant="h6" sx={{mb:2, color:'primary.main'}} gutterBottom>
        Children’s Education
        </Typography>
        
        <Typography variant="body1" sx={{ mb: 1 }}>
          How many children do you want to plan for?
        </Typography>
        
        
          <Slider
            value={numKids}
            onChange={handleSliderChange}
            step={1}
            marks={[
              { value: 0, label: 'None' },
              { value: 1, label: '1' },
              { value: 2, label: '2' },
              { value: 3, label: '3' }
            ]}
            min={0}
            max={3}
            valueLabelDisplay="auto"
            sx={{
              mr: 2,
              flexGrow: 1,
              '& .MuiSlider-valueLabelCircle': {
                backgroundColor: '#757575',
              }
            }}
          />

        {numKids > 0 && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Please enter name and birth year:
          </Typography>
        )}

        {kidsInfo.map((kid, index) => (
          <Box key={index} sx={{mb: 2 }}>
          <Typography variant="subtitle1" sx={{ mb: 1 }}>
            Child {index + 1}
          </Typography>

          <Grid container spacing={2} wrap="nowrap" alignItems="flex-start">
            <Grid item md={8} sm={8}>
            <TextField
              label="Name"
              value={kid.name || ''}
              onChange={(e) => handleInputChange(index, 'name', e.target.value)}
              size="small"
              fullWidth
              aria-label={`Child ${index + 1} name`}
              // error={!kid.name || kid.name.trim() === ""}   // error if empty or spaces only
              // helperText={
              //   !kid.name || kid.name.trim() === ""
              //     ? "Please enter a valid name"
              //     : " "
              // }
              FormHelperTextProps={{
                sx: { minHeight: 20, ml: 0 }
              }}
            />
            </Grid>

            <Grid item md={4} sm={4}>
              {(() => {
                const y = kid.yearOfBirth;
                const validYear = /^[12]\d{3}$/.test(String(y || ''));
                // const age = y ? (currentYear - Number(y)) : null;
                const msg =
                  !y ? '' :
                  !validYear ? 'Please enter a valid year' : '';
                  // (age > 25) ? 'Child age should be less than 25' : '';

                return (
                  <TextField
                    label="Birth Year"
                    value={y || ''}
                    type="text"
                    inputMode="numeric"
                    aria-label={`Child ${index + 1} birth year`}
                    inputProps={{ min: currentYear - 25, max: currentYear + 1, step: 1 }}
                    onChange={(e) => handleInputChange(index, 'yearOfBirth', e.target.value)}
                    size="small"
                    fullWidth
                    error={Boolean(msg)}
                    helperText={msg || ' '}                      // always reserve space
                    FormHelperTextProps={{
                      sx: { minHeight: 20, visibility: msg ? 'visible' : 'hidden', ml: 0 }
                    }}
                  />
                );
              })()}
            </Grid>
          </Grid>
        </Box>        
        ))}
      </Box>
    </CardContent>
  );
};

export default KidsPlanning;

